import type RegionStrapi from "~/libs/interfaces/RegionStrapi";
import type RegionLocal from "~/libs/interfaces/RegionLocal";

const regionLocalFactory = {
  createRegionFromStrapi(region?: RegionStrapi): RegionLocal | undefined {
    if (!region) {
      return undefined;
    }
    return {
      id: region.id,
      documentId: region.documentId,

      createdAt: region.createdAt ? new Date(region.createdAt) : undefined,
      updatedAt: region.updatedAt ? new Date(region.updatedAt) : undefined,
      publishedAt: region.publishedAt ? new Date(region.publishedAt) : undefined,

      code: region.code,
      name: region.name
    }
  }
}
export default regionLocalFactory